import React, { Component } from "react";
import Chip from "@material-ui/core/Chip";
import { withStyles } from "@material-ui/core/styles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { Trans, withTranslation } from "react-i18next";
import { Droppable, Draggable, DragDropContext } from "react-beautiful-dnd";
import ReactDOM from "react-dom";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";

const styles = (theme) => ({
  chip: {
    margin: theme.spacing(0.5),
    marginRight: theme.spacing(1.5),
    marginLeft: theme.spacing(1.5),
    justifyContent: "left",
    "& span": {
      marginRight: "auto",
    },
  },
});
export class ChipPickerSort extends Component {
  state = {
    includeddefault: [],
    options: [],
    topDivLabel: "",
    bottomDivLabel: "",
    settings: [],
    settingKeyName: "",
  };
  render() {
    const { classes } = this.props;
    return (
      <TableContainer>
        <Table>
          <TableHead>
            <TableCell>
              <Trans i18nKey="global_included" />
            </TableCell>
            <TableCell>
              <Trans i18nKey="global_excluded" />
            </TableCell>
          </TableHead>
          <TableBody>
            <TableCell style={{ width: "50%", verticalAlign: "top" }}>
              <DragDropContext onDragEnd={this.onChipDragEnd}>
                <Droppable droppableId="droppable" direction="vertical">
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      style={this.getStyle(snapshot.isDraggingOver)}
                      {...provided.droppableProps}
                    >
                      {this.props.included.map((item, index) => {
                        return (
                          <Draggable
                            key={item + "-" + index}
                            draggableId={item + "-" + index}
                            index={index}
                          >
                            {(provided, snapshot) => {
                              const style = {
                                ...provided.draggableProps.style,
                              };
                              const usePortal = snapshot && snapshot.isDragging;
                              const child = (
                                <Chip
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  style={style}
                                  inPortal={usePortal}
                                  key={item}
                                  onDelete={this.props.includedToExcluded.bind(
                                    this,
                                    item,
                                    this.props.extended
                                  )}
                                  label={this.props.t(item)}
                                  className={classes.chip}
                                  color={
                                    snapshot.isDragging
                                      ? "secondary"
                                      : "primary"
                                  }
                                  variant={"outlined"}
                                />
                              );
                              if (usePortal) {
                                return ReactDOM.createPortal(
                                  child,
                                  document.body
                                );
                              }
                              return child;
                            }}
                          </Draggable>
                        );
                      })}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            </TableCell>
            <TableCell style={{ width: "50%", verticalAlign: "top" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {this.props.excluded.map((item) => (
                  <Chip
                    key={item}
                    className={classes.chip}
                    label={this.props.t(item)}
                    onClick={this.props.excludedToIncluded.bind(
                      this,
                      item,
                      this.props.extended
                    )}
                  />
                ))}
              </div>
            </TableCell>
          </TableBody>
        </Table>
      </TableContainer>
    );
  }
  getStyle = (isDraggingOver) => ({
    // background: isDraggingOver
    //   ? "grey"
    //   : "white",
    // width:"100%",
    // height: "100%",
    // margin:0,
    // padding:0,
    // border:1,
    // flex: 1,
    display: "flex",
    flexDirection: "column",
  });
  reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };
  onChipDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const updatedIncluded = this.reorder(
      this.props.included,
      result.source.index,
      result.destination.index
    );
    this.props.reorderIncluded(updatedIncluded);
  };
}
export default withStyles(styles)(withTranslation()(ChipPickerSort));
